export default "__VITE_ASSET__Dq6VF7iU__"